'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _callback = require('./callback');

var _callback2 = _interopRequireDefault(_callback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TypeNotifier(type, notifier) {
    _assert2['default'].notEqual(type, void 0, 'type value cannot be undefined');

    _base2['default'].call(this);

    this.type = type;

    if (typeof notifier === 'function') {
        notifier = _callback2['default'].create(notifier);
    }

    this.notifier = notifier;
}

_base2['default'].extend(TypeNotifier, {
    notify: function notify(message) {
        if (message.type !== this.type) return;
        return this.notifier.notify(message);
    }
});

exports['default'] = TypeNotifier;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/type.js
 ** module id = 686
 ** module chunks = 0 1
 **/